import { LoadDataEvent } from "sabis-grid2";
import { LazyLoadFilterParams, LazyLoadQueryParams, SortDirection } from "./models";

export function toParams(event: LoadDataEvent): LazyLoadQueryParams {
  let filter: LazyLoadFilterParams | null = null;

  if (event.filters && event.filters.length > 0) {
    filter = {
      conditions: []
    };

    event.filters.forEach(f => {
      filter!.conditions.push({
        fieldName: f.fieldName,
        operator: f.filterOperator,
        value: f.filterValue
      });
    });
  }

  let apiParams: LazyLoadQueryParams = {
    toSkip: event.toSkip,
    rowsCount: event.toTake,
    sortDirection: event.sortDirection ? event.sortDirection === 'asc' ? SortDirection.Ascending : SortDirection.Descending : null,
    sortField: event.sortFieldName,
    filter: filter
  };

  return apiParams;
}
